import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setAccessCode } from '../api/accessCode';
import { verifyAccessCode, ApiError } from '../api/client';
import './GatePage.css';

export default function GatePage() {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim() || submitting) return;
    setError('');
    setSubmitting(true);
    try {
      await verifyAccessCode(code.trim());
      setAccessCode(code.trim());
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Verification failed. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div className="gate-page">
      <div className="gate-page__grid" aria-hidden />

      <div className="gate-page__content">
        <div className="gate-page__brand">
          <span className="gate-page__mark">D!</span>
          <span className="gate-page__name">DEBUNKED</span>
        </div>

        <h1 className="gate-page__title">
          <span className="gate-page__title-serif">Forensic photo</span>
          <span className="gate-page__title-serif">credibility scoring.</span>
        </h1>
        <p className="gate-page__subtitle">
          Restricted preview. Enter your access code to continue.
        </p>

        <form onSubmit={handleSubmit} className="gate-page__form">
          <label htmlFor="access-code" className="gate-page__label">
            ACCESS CODE
          </label>
          <div className="gate-page__input-wrap">
            <input
              id="access-code"
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="••••••••"
              disabled={submitting}
              autoFocus
              autoComplete="off"
              className="gate-page__input"
            />
            <button type="submit" disabled={submitting || !code.trim()} className="gate-page__submit">
              {submitting ? 'VERIFYING…' : 'ENTER →'}
            </button>
          </div>
          {error && <div className="gate-page__error">{error}</div>}
        </form>

        <div className="gate-page__foot">
          <span>DEBUNKED! · v0.1</span>
          <span>FORENSIC PHOTO ANALYSIS · PRIVATE PREVIEW</span>
        </div>
      </div>
    </div>
  );
}
